export function isRef<T = unknown>(obj: unknown): obj is React.RefObject<T> {
  return obj !== undefined && obj !== null && Object.prototype.hasOwnProperty.call(obj, "current");
}
